import { gql } from 'urql';
import { PRODUCT } from '../client';

export const UPDATE_LOCATIONS_ENFORCE_ITEM_SCANNING = gql`
  mutation ${PRODUCT}UpdateLocationsEnforceItemScanning($input: LocationsEnforceItemScanningUpdateInput!) {
    updateLocationsEnforceItemScanning(input: $input) {
      locations {
        id
        enforceItemScanning
      }
    }
  }
`;
